'use client';

import { useRef } from 'react';
import { AdSlot } from '@/app_components/ads/Adslot';
import { useDirectSoldFallback } from '@/app_lib/hooks/useDirectSoldFallback';
import { useAdContext } from '@/app_lib/providers/AdProvider';
import { useStickyFooter } from '@/app_lib/providers/StickyFooterProvider';
import { useUser } from '@/app_lib/providers/UserProvider';
import { cn } from '@/app_lib/utils/utils';

export const Leaderboard = () => {
  // const hideLeaderboard =
  //   pageProps?.brandedArticle?.adTags?.some((tag) => tag?.name === 'hide-leaderboard-ad') || false;
  // TODO: Implement above logic to determine if leaderboard should be hidden - should be slot page level
  const { pageAdConfig } = useAdContext();
  const { personalizedAds } = useUser();
  const { renderStickyFooter } = useStickyFooter();
  const containerRef = useRef<HTMLDivElement>(null);

  useDirectSoldFallback(personalizedAds === false ? pageAdConfig?.ch : undefined, pageAdConfig?.ctype, containerRef);

  return renderStickyFooter ? null : (
    <div
      className={cn(
        'leaderboard-ad-wrapper-parent',
        'bg-primary leading-0 tracking-none z-header flex justify-center items-center w-full text-center min-h-[110px]! md:min-h-[160px]! lg:min-h-[300px]!',
        '[&_.leaderboard-ad-wrapper]:h-auto! [&_.leaderboard-ad-wrapper]:w-full [&_div]:w-full [&_div]:flex [&_div]:justify-center',
      )}
      ref={containerRef}
    >
      {pageAdConfig && (
        <AdSlot
          index={1}
          placementName='Leaderboard'
        />
      )}
    </div>
  );
};
